export const detectIsFalse = (param?: boolean | null) : boolean => {
  return param === false;
};